import { render, staticRenderFns } from "./FavoritesSlider.vue?vue&type=template&id=2b923dca&scoped=true&"
import script from "./FavoritesSlider.vue?vue&type=script&lang=ts&"
export * from "./FavoritesSlider.vue?vue&type=script&lang=ts&"
import style0 from "./FavoritesSlider.vue?vue&type=style&index=0&id=2b923dca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b923dca",
  null
  
)

export default component.exports